// Web Audio API sound effects - no external files needed
let audioCtx = null;

function getCtx() {
  if (!audioCtx) {
    try { audioCtx = new (window.AudioContext || window.webkitAudioContext)(); } catch (e) {}
  }
  return audioCtx;
}

// Resume audio context on user interaction (required by browsers)
function unlockAudio() {
  const ctx = getCtx();
  if (ctx && ctx.state === 'suspended') ctx.resume();
}
document.addEventListener('click', unlockAudio, { once: true });
document.addEventListener('touchstart', unlockAudio, { once: true });

function playTone(frequency, duration, type = 'sine', volume = 0.15) {
  const ctx = getCtx();
  if (!ctx) return;
  try {
    const osc = ctx.createOscillator();
    const gain = ctx.createGain();
    osc.connect(gain);
    gain.connect(ctx.destination);
    osc.type = type;
    osc.frequency.value = frequency;
    gain.gain.setValueAtTime(volume, ctx.currentTime);
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + duration);
    osc.start(ctx.currentTime);
    osc.stop(ctx.currentTime + duration);
  } catch (e) {}
}

function playSequence(notes, baseDelay = 0.12) {
  const ctx = getCtx();
  if (!ctx) return;
  notes.forEach(([freq, dur, type, vol], i) => {
    setTimeout(() => playTone(freq, dur || 0.2, type || 'sine', vol || 0.12), i * baseDelay * 1000);
  });
}

// === Sound Effects ===

// Soft "ding" - phase transitions
export function playPhaseStart() {
  playSequence([[523, 0.15], [659, 0.15], [784, 0.25]], 0.1);
}

// Countdown tick
export function playTick() {
  playTone(800, 0.05, 'square', 0.06);
}

// Warning beep (timer low)
export function playWarning() {
  playTone(440, 0.15, 'square', 0.1);
}

// Time's up!
export function playTimeUp() {
  playSequence([[440, 0.2, 'square'], [330, 0.3, 'square']], 0.15);
}

// Correct answer / success
export function playCorrect() {
  playSequence([[523, 0.1], [659, 0.1], [784, 0.1], [1047, 0.3]], 0.08);
}

// Wrong answer
export function playWrong() {
  playSequence([[300, 0.15, 'sawtooth'], [250, 0.25, 'sawtooth']], 0.12);
}

// Button click feedback
export function playClick() {
  playTone(600, 0.04, 'sine', 0.06);
}

// Spy reveal - dramatic
export function playSpyReveal() {
  playSequence([
    [200, 0.2, 'sawtooth', 0.08],
    [250, 0.2, 'sawtooth', 0.1],
    [300, 0.2, 'sawtooth', 0.12],
    [400, 0.4, 'sawtooth', 0.15],
  ], 0.18);
}

// Vote cast
export function playVote() {
  playTone(500, 0.1, 'triangle', 0.08);
}

// Game over / victory fanfare
export function playVictory() {
  playSequence([
    [523, 0.12], [523, 0.12], [523, 0.12], [659, 0.2],
    [587, 0.12], [587, 0.12], [659, 0.12], [784, 0.3],
  ], 0.12);
}

// New message notification
export function playMessage() {
  playSequence([[800, 0.08], [1000, 0.12]], 0.06);
}

// Mystery reveal
export function playMysteryReveal() {
  playSequence([
    [200, 0.3, 'triangle', 0.1],
    [300, 0.3, 'triangle', 0.12],
    [250, 0.3, 'triangle', 0.1],
    [400, 0.5, 'triangle', 0.15],
  ], 0.25);
}

// Round start
export function playRoundStart() {
  playSequence([[440, 0.1], [554, 0.1], [659, 0.2]], 0.1);
}
